<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div v-show="showAdd" class="col">
          <AppAddButton v-bind:permission="permission">
          <button @click.prevent="onAddButtonClick" class="btn btn-rounded btn-block-xs-only" style="background: rgb(128, 0, 128); color: #fff;">
            Create Supplier
          </button>
          </AppAddButton>
        </div>

        <AppSearch 
          v-show="false"
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM_DISPLAY" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-bind:modalShowAdd="modalAllowAdd"
        v-bind:modalShowEdit="modalAllowEdit"
        v-bind:modalShowDelete="false"
        v-on:modal-data-input="onFormInput"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick">
        
        <div
          v-show="validateTinButtonShow"
          slot="jt-form-slot-sectionValidateTin">

          <br>

          <button type="button" class="btn btn-primary" @click="validateTin">Validate</button>

          <TemplateLoading v-show="validateTinLoading" />

          <TemplateAlert 
            v-if="validateTinError"
            v-bind:error="validateTinError" />
        </div>
        
      </AppModalForm>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import TemplateAlert from "@/components/Template/TemplateAlert";
import TemplateLoading from "@/components/Template/TemplateLoading";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM_DISPLAY = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'id',
    text: 'Supplier ID',
  },
  {
    key: 'name',
    text: 'Company Name',
    table_popup: true, 
  },
  {
    key: 'identifierValue',
    text: 'ID No.',
  },
  {
    key: 'tin',
    text: 'TIN',
  },
  {
    key: 'createdAt',
    text: 'Created Date',
  },
  {
    key: 'startDate',
    text: 'Start From Date',
  },
  {
    key: 'updatedAt',
    text: 'Updated Date',
  },
  {
    key: 'status',
    text: 'Status',
    table_custom: helper.tableCustomEnableDisable,
  },
];

const PARAM = [
  // {
  //   key: '_index',
  //   index: true,
  // },
  // {
  //   key: 'id',
  //   text: 'Supplier ID',
  // },
  {
    key: 'identifierTypeId',
    text: 'ID Type *',
    form_default: 2,
    form_add_input_attr: {
      disabled: true,
    },
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'identifierValue',
    text: 'ID No. *',
    table_hide: true,
  },
  {
    key: 'tin',
    text: 'TIN *',
    table_hide: true,
  },
  {
    key: 'sectionValidateTin',
    form_html: () => ' ',
    form_div_attr: {
      style: {
        marginBottom: '0px',
      }
    },
  },
  {
    key: 'name',
    text: 'Company Name *',
    table_popup: true, 
  },
  {
    key: 'msicId',
    text: 'MSIC Type *',
    table_hide: true,
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => `${data.id} - ${data.code}: ${data.name}`,
    },
    form_chosen: true,
  },
  {
    key: 'sst',
    text: 'SST No.',
    table_hide: true,
    form_input_validation: [],
  },
  {
    key: 'email',
    text: 'Email *',
    table_hide: true,
  },
  {
    key: 'telephone',
    text: 'Phone No. *',
    table_hide: true,
  },
  {
    key: 'address1',
    text: 'Address Line 1 *',
    table_hide: true,
  },
  {
    key: 'address2',
    text: 'Address Line 2',
    table_hide: true,
    form_input_validation: [],
  },
  {
    key: 'address3',
    text: 'Address Line 3',
    table_hide: true,
    form_input_validation: [],
  },
  {
    key: 'createdAt',
    text: 'Created Date',
    form_edit_input_attr: {
      disabled: true,
    },
    form_input_validation: [],
  },
  {
    key: 'postal',
    text: 'Postal Code *',
    table_hide: true,
    form_input_validation: [],
  },
  {
    key: 'city',
    text: 'City *',
    table_hide: true,
  },
  {
    key: 'stateId',
    text: 'State *',
    table_hide: true,
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'countryId',
    text: 'Country *',
    table_hide: true,
    form_select: [],
    form_chosen: true,
  },
  {
    key: 'updatedAt',
    text: 'Updated Date',
    form_edit_input_attr: {
      disabled: true,
    },
    form_input_validation: [],
  },
  {
    key: 'status',
    text: 'Enable',
    form_checkbox: true,
    table_custom: helper.tableCustomEnableDisable,
  },
  {
    key: 'startDate',
    text: 'Start From Date',
    form_input_validation: [],
    form_datepicker: true,
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageEInvoiceSetting",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
    TemplateAlert,
    TemplateLoading,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Bill Management' },
        { name: 'E-Invoice Setting' },
      ],

      PARAM_DISPLAY,
      PARAM,
      PARAM_MAP,

      showAdd: false,

      supplierToken: '',
      supplier: {},
      serviceToken: helper.BEE_INVOIS_SERVICE_TOKEN,

      validateTinButtonShow: false,
      validateTinLoading: false,
      validateTinError: '',

      modalAllowAdd: false,
      modalAllowEdit: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.loadSupplierIdType();
  },
  methods: {
    loadSupplierIdType() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading supplier ID type...');

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.serviceToken

      this.$http
        .get(
          helper.BEE_INVOIS_URL + '/v1/main/constraints/identifier-type/list',
          config
        )
        .then(response => {
          // let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['identifierTypeId'], response.data.record);
          this.loadSupplierMsicType();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError('Problem loading supplier ID type');
        });
    },
    loadSupplierMsicType() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading supplier MSIC type...');

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.serviceToken

      this.$http
        .get(
          helper.BEE_INVOIS_URL + '/v1/main/constraints/msic/list',
          config
        )
        .then(response => {
          // let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['msicId'], response.data.record);
          this.loadCountry();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError('Problem loading supplier MSIC type');
        });
    },
    loadCountry() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading country data...');

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.serviceToken

      this.$http
        .get(
          helper.BEE_INVOIS_URL + '/v1/main/constraints/country/list',
          config
        )
        .then(response => {
          // let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['countryId'], response.data.record);
          this.loadState();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError('Problem loading country list');
        });
    },
    loadState() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading state data...');

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.serviceToken

      this.$http
        .get(
          helper.BEE_INVOIS_URL + '/v1/main/constraints/state/list',
          config
        )
        .then(response => {
          // let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['stateId'], response.data.record);
          this.loadSupplierToken();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError('Problem loading state list');
        });
    },
    loadSupplierToken() {
      this.$refs['pageFeedback'].setFeedbackLoading('Obtaining supplier token...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/einvoice',
          helper.createAxiosConfig()
        )
        .then(response => {
          // let resultMeta = helper.processAxiosResponse(this, response);
          try {
            this.supplierToken = response.data.result[0].token
            this.supplier = response.data.result
          } catch(e) {
          }

          this.$refs['pageFeedback'].setFeedbackMessage();

          if (!this.supplierToken) {
            this.showAdd = true
            // this.$refs['pageFeedback'].setFeedbackError('Problem obtaining supplier token, please contact system administrator');
            return
          }

          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'supplier token'));
        });
    },
    async loadData() {
      this.showAdd = false

      this.$refs['pageTable'].setTablePaging(false)
      this.$refs['pageTable'].setTableLoading('Loading supplier profile...');

      let url = this.getUrl();
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      // url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.supplierToken

      this.$http
        .get(
          helper.BEE_INVOIS_URL + '/v1/supplier/profile/get',
          config
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          let profile = []

          try {
            if (response.data.record.profile) {
              let temp = response.data.record.profile
              let supplier = this.supplier.find(k => k['supplierID'] == temp['id']) || {}
              temp.status = supplier.status
              temp.startDate = moment.unix(supplier.startDate).format('YYYY-MM-DD')
              profile = [temp]
            }
          } catch(e) {
          }

          if (!profile) {
            this.showAdd = true
            this.$refs['pageTable'].setTableError('No supplier profile');
            return
          }

          for(let temp of profile) {
            temp['createdAt'] = moment(temp['createdAt']).format('YYYY-MM-DD HH:mm:ss')
            temp['updatedAt'] = moment(temp['updatedAt']).format('YYYY-MM-DD HH:mm:ss')
            // temp['startDate'] = moment(temp['startDate']).format('YYYY-MM-DD')
          }

          this.$refs['pageTable'].setTableData(profile, this.$refs['pageTable'].getCurrentPage());
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError('Problem loading supplier profile');
        })
    },

    getUrl() {
      return helper.SERVER_URL + '/api2/passtype/';
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    onAddButtonClick() {
      this.modalAllowAdd = false
      this.validateTinButtonShow = true
      this.validateTinError = ''

      for(let param of PARAM) {
        if (param['key'] === 'identifierTypeId' || param['key'] === 'identifierValue' || param['key'] === 'tin' || param['key'] === 'sectionValidateTin') {
          param['form_hide'] = false
        } else {
          param['form_hide'] = true
        }
      }

      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(true, 'Add Supplier');
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.modalAllowEdit = true
      this.validateTinButtonShow = false
      this.validateTinError = ''

      for(let param of PARAM) {
        param['form_hide'] = false
        param['form_input_attr'] = param['form_input_attr'] || {}
        param['form_input_attr']['disabled'] = false
      }

      if(this.$refs['pageModal'].$refs['modalForm'].formIsAdd) {
        PARAM_MAP['createdAt']['form_hide'] = true
        PARAM_MAP['updatedAt']['form_hide'] = true
      }

      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['name'], tableData[tableDataIndex]);
    },

    async onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding supplier ' + selectedData.name);

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.serviceToken

      selectedData['identifier'] = {
        type: selectedData['identifierTypeId'],
        value: selectedData['identifierValue'],
      }

      selectedData['msicId'] = parseInt(selectedData['msicId'])
      selectedData['stateId'] = parseInt(selectedData['stateId'])
      selectedData['countryId'] = parseInt(selectedData['countryId'])
      selectedData['status'] = selectedData['status'] ? 1 : 0

      let result = await this.$http
        .post(
          helper.BEE_INVOIS_URL + '/v1/main/supplier/add',
          selectedData,
          config,
        )
        .then(response => {
          return response.data
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError('Problem adding supplier');
        })

      if (!result || !result.record || !result.record.id || !result.record.hashToken) {
        return
      }

      this.$http
        .post(
          helper.SERVER_URL + '/api2/einvoice',
          querystring.stringify({
            supplierID: result.record.id,
            token: result.record.hashToken,
            status: selectedData.status,
            operatorID: localStorage.getItem('selectedOperatorID'),
          }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.supplierToken = result.record.hashToken
          this.upsertDataComplete('Successfully added supplier ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'supplier'));
        })
    },
    async onModalEditDataClick(selectedData1) {
      let selectedData = JSON.parse(JSON.stringify(selectedData1))
      this.$refs['pageModal'].setModalLoading('Updating supplier ' + selectedData.name);

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.supplierToken

      selectedData['identifier'] = {
        type: selectedData['identifierTypeId'],
        value: selectedData['identifierValue'],
      }

      selectedData['msicId'] = parseInt(selectedData['msicId'])
      selectedData['stateId'] = parseInt(selectedData['stateId'])
      selectedData['countryId'] = parseInt(selectedData['countryId'])
      selectedData['status'] = selectedData['status'] ? 1 : 0

      // delete selectedData['identifier']
      let startDate = helper.parseDateTime(selectedData['startDate']).startOf('day').unix()
      delete selectedData['startDate']

      let result = await this.$http
        .put(
          helper.BEE_INVOIS_URL + `/v1/supplier/profile/update`,
          selectedData,
          config,
        )
        .then(response => {
          return response.data
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError('Problem updating supplier');
        })

      if (!result || !result.record || !result.record.id || !result.record.hashToken) {
        return
      }

      this.$http
        .post(
          helper.SERVER_URL + '/api2/einvoice',
          querystring.stringify({
            supplierID: result.record.id,
            token: result.record.hashToken,
            // supplierID: selectedData.supplierID,
            // token: selectedData.token,
            status: selectedData.status,
            operatorID: localStorage.getItem('selectedOperatorID'),
            startDate: startDate,
          }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update supplier ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'supplier'));
        })
    },
    onModalDeleteDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Deleting ' + selectedData.name);

      this.$http
        .delete(
          this.getUrl(selectedData.carparkID) + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadSupplierToken();
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'identifierTypeId' || formParameter.key === 'identifierValue' || formParameter.key === 'tin') {
        this.validateTinButtonShow = true
        this.modalAllowAdd = false
        this.modalAllowEdit = false

        for(let param of PARAM) {
          param['form_input_attr'] = param['form_input_attr'] || {}
          param['form_input_attr']['disabled'] = true
        }

        delete PARAM_MAP['identifierTypeId']['form_input_attr']
        delete PARAM_MAP['identifierValue']['form_input_attr']
        delete PARAM_MAP['tin']['form_input_attr']
        this.$forceUpdate()
      } else if(formParameter.key === 'city') {
        this.onFormCityChange();
      } else if(formParameter.key === 'NoSST') {
        formData['ExemptSST'] = 0;
        formData['ExclusiveSST'] = 0;
        this.$refs['pageForm'].$forceUpdate();
      } else if(formParameter.key === 'ExclusiveSST') {
        formData['NoSST'] = 0;
        formData['ExemptSST'] = 0;
        this.$refs['pageForm'].$forceUpdate();
      }
    },
    onFormCityChange() {
        let formData = this.$refs['pageModal'].$refs['modalForm'].formData;
        formData['stateId'] = null;
        formData['countryId'] = null;
        
        let selectedCity = helper.inputSelectFindOption(PARAM_MAP['city'], formData['city']);
        if(!selectedCity) {
          return this.$refs['pageForm'].$forceUpdate();
        }

        let selectedState = helper.inputSelectFindOption(PARAM_MAP['stateId'], selectedCity.stateID);
        if(!selectedState) {
          return this.$refs['pageForm'].$forceUpdate();
        }
        formData['stateId'] = selectedState.id;

        // TODO kw1 map state to country
        let selectedCountry = helper.inputSelectFindOption(PARAM_MAP['countryId'], selectedState.countryID);
        if(!selectedCountry) {
          return this.$refs['pageForm'].$forceUpdate();
        }
        formData['countryId'] = selectedCountry.id;
        return this.$refs['pageModal'].$refs['modalForm'].$forceUpdate();
    },

    validateTin() {
      this.validateTinLoading = true
      this.validateTinError = ''

      let formData = this.$refs['pageModal'].$refs['modalForm'].formData;

      // this.$refs['pageModal'].setModalLoading('Validating TIN');

      let config = helper.createAxiosConfig()
      config['headers']['Authorization'] = 'JWT ' + this.serviceToken

      this.$http
        .get(
          helper.BEE_INVOIS_URL + `/v1/main/invois/e-invoice/taxpayer/validate/${formData['tin']}?idType=${formData['identifierTypeId']}&idValue=${formData['identifierValue']}`,
          config
        )
        .then(response => {
          // let resultMeta = helper.processAxiosResponse(this, response);

          response = response || {}
          response.data = response.data || {}

          if (response.data.record === true) {
            this.$refs['pageModal'].setModalMessage('')
            for(let param of PARAM) {
              param['form_hide'] = false
              param['form_input_attr'] = param['form_input_attr'] || {}
              param['form_input_attr']['disabled'] = false
            }

            if(this.$refs['pageModal'].$refs['modalForm'].formIsAdd) {
              PARAM_MAP['createdAt']['form_hide'] = true
              PARAM_MAP['updatedAt']['form_hide'] = true
            }

            this.modalAllowAdd = true
            this.modalAllowEdit = true

            this.$forceUpdate()
          } else if (response.data.record === false) {
            this.validateTinError = 'Invalid TIN, please try again'
          } else {
            this.validateTinError = 'Problem validating TIN, please try again'
          }
        })
        .catch(error => {
          // this.$refs['pageModal'].setModalError('Problem validating TIN, please try again');
          this.validateTinError = 'Problem validating TIN, please try again'
        })
        .finally(() => {
          this.validateTinLoading = false
        })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/BillManagement/PageEInvoiceSetting.vue